<app-merchant-details
  [identity]="identity"
  [merchant]="merchant"
  [merchants]="recentMerchants"
></app-merchant-details>
<div
  class="vf-merchant details"
  *ngIf="hasEntitlements('TAB_CARDHOLDERS_VISA_FORWARD') && !infoSet"
>
  <div style="padding: 2rem" *ngIf="!infoSet">
    <i class="fa fa-spinner fa-spin"></i>
  </div>
</div>

<form
  name="cardsForm"
  *ngIf="hasEntitlements('TAB_CARDHOLDERS_VISA_FORWARD') && infoSet"
  [formGroup]="cardsForm"
  novalidate
>
  <div class="card card-nc">
    <div class="card-heading">
      <span class="icon-NC_location"></span>
      <span class="panelHeaderHeading"> CARD </span>&nbsp;&nbsp;
      <span class="pull-right save-panel"> </span>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12 zeroPadding">
          <label for="cardsAccount" class="col-md-12 control-label labelCommon"
            >CARD</label
          >
          <div
            class="form-group col-md-12"
            *ngIf="hasEntitlements('TAB_CARDHOLDERS_VISA_FORWARD')"
          >
            <select
              class="form-control input-sm"
              id="cardsAccount"
              formControlName="cardsAccount"
              (ngModelChange)="cardChanged($event)"
            >
              <option
                *ngFor="let cardsAccount of cardsAccounts"
                value="{{ cardsAccount.cardSeq }}"
              >
                {{ cardsAccount.cardSeq }}
              </option>
            </select>
          </div>
          <div
            class="form-group col-md-12"
            *ngIf="hasEntitlements('TAB_CARDHOLDERS_VISA_FORWARD')"
          >
            <pre><code class="prettyprint" id="jsonDisplay">{{selectedCardDetails}}</code></pre>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
